import { client } from "@/contexts/ClientContext";

export interface AttendanceData {
  id: number;
  Client: client;
  attendant_id: string;
  client_id: number;
  state: string;
}

export enum AtendimentoStateEnum {
  BRIEFING = "BRIEFING",
  NEGOCIACAO = "NEGOCIACAO",
  PROPOSTA = "PROPOSTA",
  PAGAMENTO_REALIZADO = "PAGAMENTO_REALIZADO",
  CONFERENCIA_MEDIDAS = "CONFERENCIA_MEDIDAS",
  PROJETO_TECNICO = "PROJETO_TECNICO",
  PRODUCAO = "PRODUCAO",
  AGENDAR_MONTAGEM = "AGENDAR_MONTAGEM",
  REALIZOU_MONTAGEM = "REALIZOU_MONTAGEM",
  FEEDBACK = "FEEDBACK",
  POS_VENDA = "POS_VENDA"
}

export interface Atendimento {
  id: number,
  atendente_id: string,
  cliente_id: number,
  estado: "Briefing" | "Proposta" | "Produção" | "Medição" | "Projeto Técnico" | "Realizou Montagem" | "Montagem" | "Feedback" | "Venda Concluída"
  briefingId: number,
  criadoEm: Date,
  arquivado? : boolean
}

export interface EstadoAtendimento {
  estado: "Briefing" | "Proposta" | "Produção" | "Medição" | "Projeto Técnico" | "Realizou Montagem" | "Montagem" | "Feedback" | "Venda Concluída"
}

